<template>
   <div class="taza-overlay">
      <div class="taza-wrapper">
         <!-- Humo / vapor -->
         <div class="vapor-container">
            <div class="vapor v1"></div>
            <div class="vapor v2"></div>
            <div class="vapor v3"></div>
         </div>

         <!-- Taza SVG -->
         <svg
            class="taza-svg"
            viewBox="0 0 120 100"
            xmlns="http://www.w3.org/2000/svg"
         >
            <!-- Platillo -->
            <ellipse cx="56" cy="92" rx="46" ry="7" fill="#c8a97e" />
            <!-- Taza cuerpo -->
            <path
               d="M18 50 Q16 80 56 82 Q96 80 94 50 Z"
               fill="#fff8f0"
               stroke="#c8a97e"
               stroke-width="2.5"
            />
            <!-- Borde superior taza -->
            <ellipse cx="56" cy="50" rx="38" ry="8" fill="#fff8f0" stroke="#c8a97e" stroke-width="2.5" />
            <!-- Té dentro -->
            <ellipse cx="56" cy="50" rx="34" ry="6" fill="#c0703a" opacity="0.85" />
            <!-- Asa -->
            <path
               d="M94 57 Q115 57 115 68 Q115 79 94 79"
               fill="none"
               stroke="#c8a97e"
               stroke-width="4"
               stroke-linecap="round"
            />
         </svg>

         <!-- Cronómetro -->
         <div class="cronometro">{{ segundos }}</div>

         <!-- Mensaje -->
         <div class="mensaje">Preparando pagos...</div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'LoadingTaza',
   props: {
      /**
       * Desde qué número arranca la cuenta regresiva.
       *
       * Va como propiedad y no fijo en el componente porque debe coincidir con la
       * espera de la pantalla que lo usa: estaba en 5 y Pagos.vue bajó su
       * temporizador a 3, así que la cuenta terminaba en 2 y se quedaba ahí.
       */
      segundosIniciales: {
         type: Number,
         default: 3
      }
   },
   data() {
      return {
         segundos: this.segundosIniciales,
         _interval: null
      }
   },
   mounted() {
      this._interval = setInterval(() => {
         if (this.segundos > 0) this.segundos--
      }, 1000)
   },
   beforeDestroy() {
      clearInterval(this._interval)
   }
}
</script>

<style scoped>
.taza-overlay {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 48px 0;
}

.taza-wrapper {
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 8px;
}

/* ── Vapor ── */
.vapor-container {
   display: flex;
   gap: 14px;
   height: 52px;
   align-items: flex-end;
   margin-bottom: 2px;
}

.vapor {
   width: 6px;
   border-radius: 10px;
   background: linear-gradient(to top, #b0b0b0, transparent);
   animation: subirVapor 1.6s ease-in-out infinite;
   opacity: 0;
}

.v1 { height: 36px; animation-delay: 0s; }
.v2 { height: 48px; animation-delay: 0.5s; }
.v3 { height: 30px; animation-delay: 1s; }

@keyframes subirVapor {
   0%   { opacity: 0;    transform: translateY(0)    scaleX(1); }
   30%  { opacity: 0.7;  transform: translateY(-10px) scaleX(1.2); }
   70%  { opacity: 0.4;  transform: translateY(-28px) scaleX(0.8); }
   100% { opacity: 0;    transform: translateY(-48px) scaleX(1.3); }
}

/* ── Taza ── */
.taza-svg {
   width: 120px;
   height: 100px;
   filter: drop-shadow(0 4px 8px rgba(0,0,0,0.15));
   animation: mecerTaza 3s ease-in-out infinite;
}

@keyframes mecerTaza {
   0%, 100% { transform: rotate(0deg); }
   25%       { transform: rotate(1.5deg); }
   75%       { transform: rotate(-1.5deg); }
}

/* ── Cronómetro ── */
.cronometro {
   font-size: 42px;
   font-weight: 700;
   color: #795548;
   line-height: 1;
   font-variant-numeric: tabular-nums;
   transition: color 0.4s;
}

/* ── Mensaje ── */
.mensaje {
   font-size: 14px;
   color: #8d6e63;
   letter-spacing: 0.5px;
   font-weight: 500;
}
</style>
